import InputRadio from './InputRadio'

export default InputRadio



// WEBPACK FOOTER //
// ./src/components/InputRadio/index.js